import { PlusOutlined } from "@ant-design/icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Checkbox, Form, Select, Table, Input } from "antd";
import { FullHeightContainerLayout } from "components";
import moment from "moment";
import { useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;
const { Option } = Select;

// Row fields mirror what the roles service stores and returns for an assigned api key.
const RoleApiKeyList = ({ formRef, apiKeyList, apiKeys, onApiKeyChange, readOnly, onDeleteApiKey, getFormErrors, add, remove }) => {
    const [scrollToLastRow, setScrollToLastRow] = useState(false);
    return (
        <FullHeightContainerLayout
            showHeader={false}
            showFooter={true}
            content={
                <Table
                    size="small"
                    dataSource={apiKeys}
                    pagination={false}
                    scroll={{ y: "100vh" }}
                    className="form-table container-height-100"
                    data-testid={CypressTestIds.ROLES_CREDENTIALS_LIST_TABLE}
                >
                    <Column width="5%" title="No." key="index" render={(value, field, index) => index + 1} />
                    <Column
                        title={"Name"}
                        render={(value, field, index) => {
                            return (
                                <>
                                <Form.Item {...field} name={[field.name, "apiKeyId"]} {...getFormErrors(`apiKeys.${field.name}.apiKeyId`)}>
                                    <Select
                                        showSearch
                                        placeholder="Search to Select"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={(value) => onApiKeyChange(value, field)}
                                        {...(() => (readOnly ? { open: false } : {}))()}
                                        data-testid={CypressTestIds.ROLES_CREDENTIALS_LIST_NAME_SELECT}
                                    >
                                        {[...apiKeyList]
                                            .sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" }))
                                            .map((apiKey) => (
                                            <Option key={apiKey.apiKeyId} value={apiKey.apiKeyId}>
                                                {apiKey.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                {/* onApiKeyChange copies these from the selected key. They must be registered
                                    fields, otherwise the form drops them on submit and the role update is
                                    rejected because the api key name and version are required. */}
                                <Form.Item {...field} name={[field.name, "name"]} hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item {...field} name={[field.name, "version"]} hidden>
                                    <Input />
                                </Form.Item>
                                </>
                            );
                        }}
                    />
                    <Column
                        width="15%"
                        title={"Date Assigned"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item {...field} name={[field.name, "assignedDate"]}>
                                    <>
                                        {moment
                                            .utc(formRef.current.getFieldValue(["apiKeys", field.name, "assignedDate"]))
                                            .toDate()
                                            .toLocaleString()}
                                    </>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="10%"
                        title={"Active"}
                        render={(value, field, index) => {
                            return (
                                <Form.Item {...field} name={[field.name, "active"]} valuePropName="checked" initialValue={true}>
                                    <Checkbox disabled={readOnly} data-testid={CypressTestIds.ROLES_CREDENTIALS_LIST_ACTIVE_CHECK}></Checkbox>
                                </Form.Item>
                            );
                        }}
                    />
                    <Column
                        width="5%"
                        render={(value, field, index) => {
                            return (
                                <FontAwesomeIcon
                                    icon={faTrashCan}
                                    className={!readOnly ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"}
                                    onClick={() => {
                                        if (!readOnly) onDeleteApiKey(field, () => remove(field.name));
                                    }}
                                    data-testid={CypressTestIds.ROLES_CREDENTIALS_LIST_DELETE_BUTTON}
                                />
                            );
                        }}
                    />
                </Table>
            }
            footer={
                <Form.Item>
                    <Button
                        block
                        onClick={() => {
                            setScrollToLastRow(true);
                            add();
                        }}
                        disabled={readOnly}
                        data-testid={CypressTestIds.ROLES_CREDENTIALS_LIST_ADD_CREDENTIAL_BUTTON}
                    >
                        <PlusOutlined />
                        {apiKeys.length === 0 ? "Add API key" : "Add another API key"}
                    </Button>
                </Form.Item>
            }
        ></FullHeightContainerLayout>
    );
};

export default RoleApiKeyList;
